module.exports = __webpack_public_path__ + "img/test-header.34428656.png";